/* eslint-disable no-nested-ternary */
import { isBoolean } from 'lodash';
import React from 'react';
import { View, StyleSheet, ViewProps } from 'react-native';

interface Props extends ViewProps {
  children?: any;
  flex?: number | boolean;
  backgroundColor?: string;
  borderRadius?: number;
  padding?: number;
  paddingLeft?: number;
  paddingRight?: number;
  paddingTop?: number;
  paddingBottom?: number;
  paddingVertical?: number;
  paddingHorizontal?: number;
  margin?: number | string;
  marginHorizontal?: number | string;
  marginVertical?: number | string;
  marginLeft?: number | string;
  marginRight?: number | string;
  marginTop?: number | string;
  marginBottom?: number | string;
  width?: number | string | undefined;
  height?: number | string | undefined;
}
export const Center = (props: Props) => {
  const {
    style,
    flex,
    borderRadius,
    backgroundColor,
    width,
    height,
    padding,
    paddingTop,
    paddingBottom,
    paddingLeft,
    paddingRight,
    paddingHorizontal,
    paddingVertical,
    margin,
    marginHorizontal,
    marginVertical,
    marginBottom,
    marginTop,
    marginLeft,
    marginRight,
    children,
    ...otherProps
  } = props;
  return (
    <View
      style={[
        styles.wrapper,
        flex ? (isBoolean(flex) ? { flex: 1 } : { flex }) : null,
        backgroundColor ? { backgroundColor } : null,
        borderRadius ? { borderRadius } : null,
        {
          padding,
          paddingHorizontal,
          paddingVertical,
          paddingTop,
          paddingBottom,
          paddingLeft,
          paddingRight,
        },
        {
          margin,
          marginHorizontal,
          marginVertical,
          marginBottom,
          marginTop,
          marginLeft,
          marginRight,
        },
        !!width && { width },
        !!height && { height },
        style,
      ]}
      {...otherProps}>
      {children}
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    justifyContent: 'center',
    alignItems: 'center',
  },
});
